module.exports = __webpack_public_path__ + "static/media/pevgo.792ad8f6.png";